import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useParams } from "react-router-dom";
import { postData, serverURL } from "../../services/NodeServices";
import ProductDetails from "./ProductDetails";
import YouMayAlsoLike from "../../components/YouMayAlsoLike/YouMayAlsoLike";

import { useLocation } from 'react-router-dom';
import ReviewList from "./Review";


// Image Gallery Component
const ImageGallery = ({ images, selectedImage, onImageSelect }) => {
  return (
    <div className="w-full sm:w-2/3">
      {/* Mobile Layout: Main image + thumbnail carousel */}
      <div className="block md:hidden">
        {/* Main Selected Image */}
        <div className="mb-4">
          <div className="bg-gray-50  rounded-lg overflow-hidden border">
            <img
              src={`${serverURL}images/${images[selectedImage]}`}
              alt={`Selected view ${selectedImage + 1}`}
              className="w-full h-full object-cover aspect-[3/4]"
              loading="eager"
            />
          </div>
        </div>
        
        {/* Thumbnail Carousel */}
        <div className="relative">
          <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide snap-x snap-mandatory">
            {images.map((image, index) => (
              <button
                key={index}
                onClick={() => onImageSelect(index)}
                className={`
                  flex-shrink-0
                  w-16 h-16
                  bg-gray-50 
                  rounded-md 
                  overflow-hidden 
                  
                  transition-all 
                  duration-200
                  snap-start
                  ${
                    selectedImage === index
                      ? "ring-2 ring-blue-200"
                      : "border-gray-200 hover:border-gray-300"
                  }
                `}
              >
                <img
                  src={`${serverURL}images/${image}`}
                  alt={`Thumbnail ${index + 1}`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Tablet/Desktop Layout: Grid view */}
      <div className="hidden md:block">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-3 md:gap-4">
          {images.map((image, index) => (
            <button
              key={index}
              onClick={() => onImageSelect(index)}
              className={`
                bg-gray-50 
                aspect-[3/4]
                rounded-lg 
                overflow-hidden 
                border-2
                transition-all 
                duration-200 
                ease-in-out
                
                
              
                ${
                  selectedImage === index
                    ? " ring-2 ring-blue-200"
                    : "border-transparent hover:border-gray-300"
                }
              `}
            >
              <img
                src={`${serverURL}images/${image}`}
                alt={`View ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-200 hover:scale-105"
                loading="lazy"
              />
            </button>
          ))}
        </div>
      </div>

      {/* Custom scrollbar styles */}
      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

// Product Details Component

// Main Product Page
const ProductPage = () => {
  const [selectedImage, setSelectedImage] = useState(0);

  const [loading, setLoading] = useState(true);

  const [myproduct, setMyProduct] = useState(false);
  const [allReviews, setAllReviews] = useState([]);
  const [myVariant, setMyVariant] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedSizes, setSelectedSizes] = useState("");
  const [availableSizes, setAvailableSizes] = useState([]);
  const [availableColors, setAvailableColors] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedStock,setSelectedStock]=useState('')

  const [selectedPrice, setSelectedPrice] = useState([]);
  const [selectedCurrentPrice, setSelectedCurrentPrice] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpanded2, setIsExpanded2] = useState(false);
  const [isExpanded3, setIsExpanded3] = useState(false);









  const { product_id } = useParams();
















  const { pathname } = useLocation();
  
  useEffect(() => {
    // Routes that should NOT scroll to top
    const excludedRoutes = [
      '/cart',
      '/checkout',
      '/account/orders',
      '/view/', // if you have review tabs
      '/search' // if you want to maintain search position
    ];
    
    // Check if current route is excluded
    const shouldSkipScroll = excludedRoutes.some(route => 
      pathname.includes(route)
    );
    
    if (!shouldSkipScroll) {
      console.log('Scrolling to top for:', pathname);
      window.scrollTo(0, 0);
    } else {
      console.log('Skipping scroll for excluded route:', pathname);
    }
    
  }, [pathname]);










  useEffect(() => {
    if (!myproduct) {
      getProductData(product_id);
    }
  }, []);

   useEffect(() => {
    
      getProductData(product_id);
    
  }, [product_id]);

  const getProductData = async (product_id) => {
    const result = await postData("api/products/byid", {
      product_id: product_id,
    });
    if (result.status) {
      setAllReviews(result.allreviews);
      setSelectedVariant(result?.variants[0]?.variant_id);
      setSelectedColor(result.variants[0].color);

      const available = result.variants
        .filter((variant) => variant.color == result.variants[0].color)
        .map((variant) => variant.size);

      setAvailableColors([
        ...new Set(result.variants.map((variant) => variant.color)),
      ]);
      setAvailableSizes(available);

      const selected = result.variants.find(
        (variant) =>
          variant.color === result.variants[0].color &&
          variant.size === result.variants[0].size
      );
      setSelectedPrice(selected.price);
      setSelectedCurrentPrice(selected.current_price);
      
      


      setSelectedImages(selected.image_url.split(","));
      setSelectedSizes(result.variants[0].size);

      setMyVariant(result.variants);
      setMyProduct(result.product);
    }
    setLoading(false);
  };

  const handleColorClick = (color) => {
    console.log("atm color is", selectedColor);
    console.log("color will be", color);
    let selected;
    const available = myVariant
      .filter((variant) => variant.color == color)
      .map((variant) => variant.size);
    console.log("aall avaible sizes are color is", available);
    setAvailableSizes(available);
    

    if (!available.includes(selectedSizes)) {
      setSelectedSizes(available[0]);
      console.log("as size wasnt avaiable sieswitched to", available[0]);
      selected = myVariant.find(
        (variant) => variant.color === color && variant.size === available[0]
      );
      setSelectedPrice(selected.price);
      setSelectedCurrentPrice(selected.current_price);
    } else {
      selected = myVariant.find(
        (variant) => variant.color === color && variant.size === selectedSizes
      );
      setSelectedPrice(selected.price);
      setSelectedCurrentPrice(selected.current_price);
    }
    console.log("ewn we getting for size", selectedSizes, color);

    setSelectedImages(selected.image_url.split(","));
    setSelectedVariant(selected.variant_id);
    setSelectedColor(color);

    console.log("console log product changed to new slectd product", selected);
  };

  const handleSizeClick = (size) => {
    setSelectedSizes(size);

    const selected = myVariant.find(
      (variant) => variant.color === selectedColor && variant.size === size
    );
    setSelectedImages(selected.image_url.split(","));
    setSelectedVariant(selected.variant_id);
  };




useEffect(() => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  requestAnimationFrame(scrollToTop);
  setTimeout(scrollToTop, 100); // backup for mobile
}, [product_id]);



  useEffect(() => {
    setTimeout(()=>{

      window.scrollTo(0, 0);
    },3111)
  }, []);


  
// Solution 1: Force multiple scroll attempts with requestAnimationFrame
useEffect(() => {
  console.log('scrolledddddddddddddddddddddddd');
  
  const scrollToTop = () => {
    // Try multiple methods
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    
    // Force on the main container if it exists
    const mainContainer = document.querySelector('body');
    if (mainContainer) {
      mainContainer.scrollTop = 0;
    }
  };

  // Multiple attempts with different timing
  scrollToTop();
  
  requestAnimationFrame(() => {
    scrollToTop();
    console.log('After RAF scroll:', window.pageYOffset);
  });
  
  setTimeout(() => {
    scrollToTop();
    console.log('After timeout scroll:', window.pageYOffset);
  }, 0);
  
  setTimeout(() => {
    scrollToTop();
    console.log('After 100ms scroll:', window.pageYOffset);
  }, 100);
  
}, [product_id]);
 

// Add this single useEffect after all your other useEffects
useEffect(() => {
  if (!loading && myproduct) {
    // Multiple scroll attempts with different timings
    const scrollNow = () => {
      window.scrollTo(0, 0);
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // Also try scrolling the main container
      const appDiv = document.querySelector('.App');
      if (appDiv) appDiv.scrollTop = 0;
      
      const mainDiv = document.querySelector('.min-h-screen');
      if (mainDiv) mainDiv.scrollTop = 0;
    };

    // Immediate
    scrollNow();
    
    // After React updates DOM
    setTimeout(scrollNow, 0);
    
   
    
    // Final backup
    setTimeout(scrollNow, 200);
  }
}, [loading, myproduct, product_id]);
  return (
    <div className="min-h-screen bg-white w-full">
      {loading ? (
        <>
        
        <div className="min-h-[91vh] w-full bg-[#fff]"></div>
        
        </>
      ) : (
        <>
          <div className="w-full mt-[41px] px-6 py-16 sm:py-8 sm:mt-[121px] max-xs:px-2 ">
            <div className="w-full flex flex-col lg:flex-row gap-2 ">
              <ImageGallery
                images={selectedImages}
                selectedImage={selectedImage}
                onImageSelect={setSelectedImage}
                
              />
              <ProductDetails
                product={myproduct}
                handleColorClick={handleColorClick}
                handleSizeClick={handleSizeClick}
                availableColors={availableColors}
                availableSizes={availableSizes}
                selectedColor={selectedColor}
                selectedSizes={selectedSizes}
                selectedVariant={selectedVariant}
                myVariant={myVariant}
              />

          
            </div>
                <ReviewList product_id={myproduct.product_id}/>
          </div>
        
        </>
      )}

        <YouMayAlsoLike category={myproduct.productcategoryname}/>
    </div>
    
  );
};

export default ProductPage;
